<template>
  <div class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] rounded-md">
    <div class="trezo-card-content">
      <img
        src="@/assets/images/events/event-details.jpg"
        alt="event-details-image"
        class="rounded-md"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "EventDetailsImage",
};
</script>
